// Navigation url builders

export function getCreateGroupHref({ absolute = false }: { absolute?: boolean } = {}) {
  return `${absolute ? getCleanOrigin() : ''}/new`;
}

export function getCreateGroupSuccessHref({ absolute = false }: { absolute?: boolean } = {}) {
  return `${absolute ? getCleanOrigin() : ''}/new/success`;
}

/** Links already shared with participants use `/s/`, so it must never change. */
export function getGroupHref({
  groupId,
  absolute = false,
}: {
  groupId: string;
  absolute?: boolean;
}) {
  return `${absolute ? getCleanOrigin() : ''}/s/${groupId}`;
}

// Helpers

function getCleanOrigin() {
  return window.location.origin.replace('//www.', '//'); // Remove www. from origin if present
}
